import GameStateController from 'app/src/game/GameStateController';
import InstructionNodeDragPreview from 'app/src/game/InstructionNodeDragPreview';
import InstructionsArchiveController from 'app/src/game/InstructionsArchiveController';
import LevelDisplay from 'app/src/game/LevelDisplay';
import ProgramChangeController from 'app/src/game/ProgramChangeController';
import ProgramStoreController from 'app/src/game/ProgramStoreController';
import { LevelDescription } from 'app/src/LevelDescription';
import LevelLoader from 'app/src/LevelLoader';
import LevelParser from 'app/src/LevelParser';
import useAsyncEffect from 'app/src/utils/useAsyncEffect';
import * as React from 'react';

type Props = {
	level: string;
};

export default function Level({ level }: Props): React.ReactElement | null {
	const [levelDescription, setLevelDescription] = React.useState<LevelDescription | null>(null);

	useAsyncEffect(
		async (isMounted) => {
			if (!isMounted()) {
				return;
			}

			// Load new level description.
			const levelData = await LevelLoader.sharedInstance.load(level);
			const description = LevelParser.sharedInstance.parse(levelData);
			setLevelDescription(description);

			return (): void => {
				if (!isMounted()) {
					return;
				}

				setLevelDescription(null);
			};
		},
		[level],
	);

	if (!levelDescription) {
		return <h1 className="LevelLoader-loadingText">Loading…</h1>;
	}

	return (
		<React.Fragment>
			<InstructionNodeDragPreview />
			<ProgramStoreController>
				<InstructionsArchiveController
					initialInstructionCounts={levelDescription.instructionCounts}
				>
					<GameStateController levelDescription={levelDescription}>
						<ProgramChangeController />
						<LevelDisplay />
					</GameStateController>
				</InstructionsArchiveController>
			</ProgramStoreController>
		</React.Fragment>
	);
}
